<template>

<div>
  <PageTitle :route="$route" />

  <PageRowWrapper>
    <SystemModulesForm />
  </PageRowWrapper>
</div>

</template>

<script>
import PageTitle from '@/components/layout/PageTitle'
import PageRowWrapper from '@/components/layout/PageRowWrapper'
import SystemModulesForm from '@/components/settings/users/systemModules/SystemModulesForm'

export default {
  name: 'SystemModuleAdd',
  components: {
    PageTitle,
    PageRowWrapper,
    SystemModulesForm
  }
}
</script>
